import { get } from 'dot-prop';
import { classNames } from 'libs/react';
import { useContext } from 'libs/react';
import { getColumns } from './schema';
import { Icon } from 'components/Icon';
import { TableContent } from 'components/table/private/TableContent';
import { TableContext } from 'components/table/Table';
import { Text } from 'components/Text';
import { Fragment } from 'libs/react';
import { React } from 'libs/react';
import './TableBody.scss';
/**
 * @component TableBody
 * @since 1.0.0
 * @hidden
 */
export function TableBody(props) {
    var _a;
    const { style, ready, schema, values, emptyMessagePicto, emptyMessageTitle, emptyMessageInfos, accordion, openedAccordionIds, additionalInformationFilteredIds, onRowClick } = Object.assign({ ready: true, style: 'normal' }, props);
    const { sortField, sortOrder } = useContext(TableContext);
    const className = classNames('table-body', 'table-body--' + style);
    if (ready && values.length == 0) {
        return (React.createElement("tbody", { className: className },
            React.createElement("tr", { className: "table-row" },
                React.createElement("td", { className: "table-cell table-empty-message", colSpan: getColumns(schema).length },
                    emptyMessagePicto && (React.createElement(Icon, { className: "table-empty-message-picto", value: emptyMessagePicto })),
                    emptyMessageTitle && (React.createElement(Text, { className: "table-empty-message-title", value: emptyMessageTitle })),
                    emptyMessageInfos && (React.createElement(Text, { className: "table-empty-message-infos", value: emptyMessageInfos }))))));
    }
    const sorted = values.slice();
    if (sortField && sortOrder) {
        const keyPath = (_a = schema[sortField]) === null || _a === void 0 ? void 0 : _a.column;
        if (keyPath) {
            sorted.sort((a, b) => {
                const aval = typeof keyPath == 'function' ? keyPath(a) : get(a, keyPath);
                const bval = typeof keyPath == 'function' ? keyPath(b) : get(b, keyPath);
                // Gérer les valeurs null/undefined
                if (aval == null && bval == null)
                    return 0;
                if (aval == null)
                    return 1;
                if (bval == null)
                    return -1;
                // Comparaison insensible à la casse pour les chaînes de caractères
                if (typeof aval === 'string' && typeof bval === 'string') {
                    const comparison = aval.localeCompare(bval, undefined, {
                        sensitivity: 'base',
                        numeric: true
                    });
                    return sortOrder === 'asc' ? comparison : -comparison;
                }
                // Comparaison normale pour les nombres et autres types
                switch (sortOrder) {
                    case 'asc':
                        return aval > bval ? 1 : aval < bval ? -1 : 0;
                    case 'desc':
                        return aval < bval ? 1 : aval > bval ? -1 : 0;
                }
                return 0;
            });
        }
    }
    const Accordion = ({ accordion, value, openedAccordionIds, additionalInformationFilteredIds }) => {
        if (!accordion)
            return null;
        return accordion({
            data: value,
            show: openedAccordionIds === null || openedAccordionIds === void 0 ? void 0 : openedAccordionIds.includes(value.id),
            additionalInformationFilteredIds: additionalInformationFilteredIds
        });
    };
    return (React.createElement("tbody", { className: className }, sorted.map((value, index) => {
        var _a;
        return (React.createElement(Fragment, { key: (_a = value.id) !== null && _a !== void 0 ? _a : index },
            React.createElement(TableContent, { schema: schema, value: value, onRowClick: onRowClick }),
            React.createElement(Accordion, { accordion: accordion, value: value, openedAccordionIds: openedAccordionIds, additionalInformationFilteredIds: additionalInformationFilteredIds })));
    })));
}
